import Image, { ImageProps } from "next/image";

import cmsImageLoader from "utils/cmsImageLoader";

export function CMSImage(props: ImageProps) {
    return (
        <Image
            {...props}
            alt={props.alt}
            loader={cmsImageLoader}
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
        />
    );
}
